/** Created by azhou on 2019/3/22.*/
<template>
    <div>
      <public-title>{{accountId>0 ? '编辑':'添加'}}账号
        <span class="text-link ml-auto h6" slot="right" @click="$router.back()">返回列表</span>
      </public-title>
      <div class="bg-white p-5">
        <left-text-border class="mb-2" leftText="登录账号" v-model="accountInfo.username" :disabled="Boolean(accountId)"/>
        <left-text-border class="mb-2" leftText="登录密码" v-model="password" type="password"/>
        <left-text-border class="mb-2" leftText="确认密码" v-model="confirmPassword" type="password"/>
        <left-text-border class="mb-2" leftText="姓名" v-model="accountInfo.truename"/>
        <left-text-border class="mb-2" leftText="手机号" v-model="accountInfo.mobile"/>
        <div class="d-center-start mb-2" v-if="accountId">
          <left-text leftText="是否禁用"/>
          <el-radio v-model="accountInfo.status" label="0" :disabled="singleAdmin">是</el-radio>
          <el-radio v-model="accountInfo.status" label="1" :disabled="singleAdmin">否</el-radio>
        </div>
        <div class="d-center-start mb-2">
          <left-text leftText="职位"/>
          <el-select class="w-100" v-model="accountInfo.position_id" placeholder="请选择职位" :disabled="singleAdmin">
            <el-option v-for="item in positionLists.lists" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </div>
        <el-button type="primary" @click="submitForm">提交</el-button>
      </div>
    </div>
</template>

<script>
  import { mapState,mapGetters, mapActions } from 'vuex'

  export default {
    name: 'addEditAdmin',
    computed: {
      ...mapState(['positionLists','userLoginMessage']),
      ...mapGetters(['storeInfo','isAdmin']),
      accountId() { return this.$route.query.account; },
      queryCon() { return this.$route.query },
      singleAdmin () { return this.isAdmin && this.userLoginMessage.position_id != 5 }
    },
    data() {
      return {
        accountInfo:{},
        password:'',
        confirmPassword:''
      }
    },
    created() {
      this.accountInfo = {
        ...this.queryCon,
        position_id:this.queryCon.position_id ? Number(this.queryCon.position_id) : '',
        status:String(this.queryCon.status),
      };
      this.getUserPositionLists({
        type:1,
        num:100
      })
    },
    methods:{
      ...mapActions(['getUserPositionLists','addEditAdmin']),
      validateForm() {
        if (!this.accountInfo.username) return {code:false,msg:'账号不得为空'};
        if (!this.accountInfo.truename) return {code:false,msg:'姓名不得为空'};
        if (!this.$GFUN.isPhone(this.accountInfo.mobile)) return {code:false,msg:'手机号不正确'};
        if (!this.accountInfo.position_id) return {code:false,msg:'请选择职位'};
        //添加账号的情况
        if (!this.accountId) {
          if (!this.password || !this.confirmPassword) return {code:false,msg:'请填写密码信息'};
        }
        return {code:true,msg:'验证通过'}
      },
      //添加、编辑管理员账号
      submitForm() {
        let result = this.validateForm();
        if (result.code) {
          this._confirm('确认提交信息么？',() => {
            let data = {
              truename: this.accountInfo.truename,
              mobile: this.accountInfo.mobile,
              position_id: this.accountInfo.position_id,
              username: this.accountInfo.username,
              status:1
            }
            if (!this.accountId) {    //添加账号的参数
              data.pwd = this.password;
              data.pwd2 = this.confirmPassword;
            } else {                  //编辑账号的参数
              data.status = this.accountInfo.status;
              data.id = this.accountInfo.account;
              if (this.password && this.confirmPassword) {
                data.pwd = this.password;
                data.pwd2 = this.confirmPassword;
              }
            }
            this.addEditAdmin({
              type:this.accountId ? 'edit' : 'add',
              data
            })
          })
        } else this._alert(result.msg,null,'error')
      }
    }
  }
</script>
